






import { Vue, Component, Model, Emit, Prop } from "vue-property-decorator";

@Component
export default class ErrorPopup extends Vue {
  @Model("input", { type: Boolean, required: true })
  show!: boolean;

  @Emit("input")
  emitClose() {
    return false;
  }

  @Prop({
    type: String,
    default: "Một lỗi lạ lùng đã xảy ra. Vui lòng thử lại sau!"
  })
  message!: string;
}
